import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import _ from 'lodash';

import {ReactComponent as Arrow} from '../../../assets/icons/slider-arrow.svg';

import { isRailBookers } from '../../../configuration/brand';

import '../../../styles/scss/elements/hero-slider.scss';
import '../../../styles/scss/elements/slick.scss';
import '../../../styles/scss/elements/slick-theme.scss';

/* eslint-disable-next-line react/prop-types */
const PrevArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props} aria-label="Previous" type="button">
    <Arrow className="image-carousel-arrow image-carousel-arrow-left" />
    <div className="image-carousel-arrow-background" />
  </button>
);
/* eslint-disable-next-line react/prop-types */
const NextArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props} aria-label="Next" type="button">
    <Arrow className="image-carousel-arrow" />
    <div className="image-carousel-arrow-background" />
  </button>
);

const HeroSlider = ({ images }) => {
  const isSingleImage = images.length === 1
  return (
    <div className="hero-slider-container">
      <Slider
        className={`image-carousel-container ${isSingleImage ? 'single-image-slider' : 'multi-images-slider'}`}
        dots
        infinite={!isSingleImage}
        prevArrow={<PrevArrow />}
        nextArrow={<NextArrow />}
        slidesToScroll={1}
        slidesToShow={1}
        centerMode={isRailBookers() && !isSingleImage}
      >
        {_.map(images, (image, index) => (
          <div key={`${index}`}>
            <img alt={_.get(image, 'description')} src={_.get(image, 'path')} />
            <div className="background-gradient" />
          </div>
        ))}
      </Slider>
    </div>
  );
};

HeroSlider.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default HeroSlider;
